import './imageCircle.scss';

export const ImageCircles = angular
    .module('app.components.imageCircle', [])
    .component('imageCircles', {
        template: `
            <div class="image-circle-group">
                <image-circle
                    ng-repeat="item in $ctrl.items | limitTo: $ctrl.numToShow track by $index"
                    image-uri="item.image"
                    badge="item.badge || $ctrl.badge"
                    style="height: {{$ctrl.size}}px; width: {{$ctrl.size}}px; font-size: {{$ctrl.size}}px;">
                </image-circle>
                <image-circle ng-if="($ctrl.plusButton && $ctrl.items.length === 0)" 
                              plus-button="$ctrl.plusButton" badge="$ctrl.badge" class="image-circle__button"
                              style="height: {{$ctrl.size}}px; width: {{$ctrl.size}}px; font-size: {{$ctrl.size}}px;">
                </image-circle>
            </div>
        `,
        bindings: {
            items: '<',
            numToShow: '<',
            badge: '<',
            size: '<',
            plusButton: '<'
        }
    }).component('imageCircle', {
        template: `
            <div class="image-circle"
                ng-class="{'image-circle--more': $ctrl.showMore}"
                style="background-image: url('{{$ctrl.imageUri}}');">
                <md-icon ng-if="(!$ctrl.plusButton && (!$ctrl.imageUri || $ctrl.imageUri === ''))" 
                         class="image-circle__offer">local_offer</md-icon>
                <md-button ng-if="$ctrl.plusButton" 
                           class="md-icon-button image-circle__plus"><md-icon>add</md-icon></md-button>
                <div class="image-circle__badge" ng-if="$ctrl.badge">{{$ctrl.badge}}</div>
            </div>
        `,
        bindings: {
            imageUri: '<',
            showMore: '<',
            badge: '<',
            plusButton: '<'
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/imageCircle/imageCircle.js